import { Box } from '@mui/material'
import { useState } from 'react'

import {
  ProviderInformation,
  ProviderUser,
} from '../../../providers/ProviderDetails/types'
import {
  AccessRoleList,
  Provider,
  ProviderList,
} from '../../../providers/ProvidersProvider/types'
import { EditProviderModal } from './partials/EditProviderModal'
import { EditScheduleLinkModal } from './partials/EditScheduleLinkModal'
import { ListView } from './partials/ListView.partial'
import { ViewType } from './types'

interface ProvidersViewProps {
  viewMode: ViewType
  myProviderDetails: ProviderUser | null
  providers: ProviderList | null
  providerAccessRoles: AccessRoleList | null
  selectedProvider: Provider | null
  selectedScheduleProvider: ProviderInformation | null
  editProviderModal: boolean
  editScheduleLinkModal: boolean
  setEditScheduleLinkModal: React.Dispatch<React.SetStateAction<boolean>>
  setEditProviderModal: React.Dispatch<React.SetStateAction<boolean>>
  handleEditProviderModal: (selectedProviderID: number) => void
  handleEditScheduleProviderModal: (selectedProviderID: number) => void
  handleEditProviderAccess: (
    selectedProvider: Provider,
    accessRoleId: number
  ) => Promise<void>
  onRefetchScheduleProvider: () => void
}

export const ProvidersView = ({
  viewMode,
  myProviderDetails,
  providers,
  providerAccessRoles,
  selectedProvider,
  selectedScheduleProvider,
  editProviderModal,
  editScheduleLinkModal,
  setEditProviderModal,
  setEditScheduleLinkModal,
  handleEditProviderModal,
  handleEditScheduleProviderModal,
  handleEditProviderAccess,
  onRefetchScheduleProvider,
}: ProvidersViewProps) => {
  const [isEditLoading, setIsEditLoading] = useState<boolean>(false)

  return (
    <Box>
      {editProviderModal && selectedProvider && (
        <div className='modal-container'>
          <div className='deactivate-modal'>
            <EditProviderModal
              selectedProvider={selectedProvider}
              editProviderModal={editProviderModal}
              setEditProviderModal={setEditProviderModal}
              providerAccessRoles={providerAccessRoles}
              handleEditProviderAccess={handleEditProviderAccess}
              setIsEditLoading={setIsEditLoading}
            />
          </div>
        </div>
      )}

      {editScheduleLinkModal && selectedScheduleProvider && (
        <div className='modal-container'>
          <div className='deactivate-modal'>
            <EditScheduleLinkModal
              selectedScheduleProvider={selectedScheduleProvider}
              editScheduleLinkModal={editScheduleLinkModal}
              setEditScheduleLinkModal={setEditScheduleLinkModal}
              onRefetchProvider={onRefetchScheduleProvider}
            />
          </div>
        </div>
      )}

      {viewMode === ViewType.List && providers && providerAccessRoles && (
        <ListView
          myProviderDetails={myProviderDetails}
          providers={providers}
          providerAccessRoles={providerAccessRoles}
          selectedProvider={selectedProvider}
          selectedScheduleProvider={selectedScheduleProvider}
          handleEditProviderModal={handleEditProviderModal}
          handleEditScheduleProviderModal={handleEditScheduleProviderModal}
          isEditLoading={isEditLoading}
        />
      )}
    </Box>
  )
}
